import { Box, Typography } from "@mui/material";
import { Warning } from "@tiny/icons";
import React from "react";

/**
 * Dark amber, 6.6:1 on white (WCAG AA). The themes' yellows are too light for
 * text (the email theme's yellow.125 is ~1.7:1), and color="warning" renders
 * cyan in this theme.
 */
export const DELAY_WARNING_COLOR = "#8A5300";

/** The Specific-date "date passed" warning or validation error, with an icon. */
const DelayDateNote = ({
  severity,
  children,
}: {
  severity: "warning" | "error";
  children: React.ReactNode;
}) => (
  <Box
    role={severity === "error" ? "alert" : "status"}
    sx={{
      display: "flex",
      alignItems: "center",
      gap: 1,
      color: severity === "error" ? "error.main" : DELAY_WARNING_COLOR,
    }}
  >
    <Warning sx={{ fontSize: 16, color: "inherit" }} />
    <Typography variant="p3" fontWeight={600} color="inherit">
      {children}
    </Typography>
  </Box>
);

export default DelayDateNote;
